import { Typography, Grid } from "@mui/material";

const AppointmentListHead = (): React.JSX.Element => {
  const RenderTileLabel = ({ text }: { text: string }): React.JSX.Element => (
    <Typography variant="caption" color="initial">
      {text}
    </Typography>
  );

  return (
    <Grid
      container
      columnSpacing={0}
      sx={{
        px: 2,
        py: 1,
      }}
    >
      <Grid item xs={12} sm={6} md={2}>
        <RenderTileLabel text="Datum" />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <RenderTileLabel text="Zeitraum" />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <RenderTileLabel text="Teilnehmer (Nachname, Vorname)" />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <RenderTileLabel text="Telefon" />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <RenderTileLabel text="Email" />
      </Grid>
    </Grid>
  );
};

export default AppointmentListHead;
